import React from 'react';
import { Modal } from 'react-native'

export default function ModalMobile ({ children, showModal }) {

    return(
        <Modal
            animationType='slide'
            transparent={true}
            visible={showModal}
            isVisible={2}
            style={{flex:1, justifyContent: 'flex-end', margin:50 }}
        >
            {children}
        </Modal>
    )
}
